export const BASE_API_URL = '/api/v1' as const;

export const ENDPOINTS = {
  APPS: {
    STUDIES: `${BASE_API_URL}/apps/studies`,
    STUDY: `${BASE_API_URL}/apps/study`,
  },
  AUTH: {
    SESSION: `${BASE_API_URL}/auth/session`,
    USER: {
      CURRENT: `${BASE_API_URL}/auth/user/current`,
    },
  },
  BLOOD_REPORTS: {
    BASE: `${BASE_API_URL}/blood-reports`,
    METADATA: `${BASE_API_URL}/blood-reports/metadata`,
  },
  CWF: {
    DOCUMENT_TYPES: `${BASE_API_URL}/cwf/document-types`,
    DOCUMENTS: {
      ACTIVE: `${BASE_API_URL}/cwf/documents/active`,
      CARE_PLANS: `${BASE_API_URL}/cwf/documents/careplans`,
      STUDY: `${BASE_API_URL}/cwf/documents/study`,
    },
  },
  PATIENT: `${BASE_API_URL}/patient`,
} as const;
